import React, { memo, useEffect, useRef, useState } from 'react'
import { init } from '../../auth/handleTokens';
import TagInputs from './TagInputs';

const ModalEditContact = memo(({contactSelect, contacts, saveContact, start}) => {
  

  const [name, setName] = useState(contactSelect[0]);
  const [lastname, setLastname] = useState(contactSelect[1]);
  const [celphone, setCelphone] = useState(contactSelect[2]);
  const [birthday, setBirthday] = useState(contactSelect[3]);

  const divGroupsRef = useRef();
  const btnClose = useRef();

  useEffect(()=>{
    if(!start){
      datacontact();
    }
  },[contactSelect, contacts])

  const datacontact = () => contacts.map((contact) => {
    if(contact._id === contactSelect) {
      setName(contact.name);
      setLastname(contact.lastname);
      setCelphone(contact.celphone);
      setBirthday(contact.birthday);
      return
    }
  })

    const updateContact = async()=> {
      const result = await init();
      if(!result) return window.location.href = '/login';
      saveContact({nameContact: name, lastname, celphone, birthday, divGroupsRef, update: true, contactSelect, btnClose})
      btnClose.current.click();
    }

    return ( 
        <>
          <div className=' container modal-header'>
                  
            <div className='modal-title'>
              <img alt="Logo SMS-APP" className="rounded-circle" style= {{width: '7%'}} src="/SMS-APP.png" />
              <h2 style={{fontSize: '20px'}} className="font-weight-bold text-white"> SMS APP</h2>
              <button ref={btnClose}  style={{backgroundColor: 'white'}} type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
          </div>
          <div className='modal-body text-center text-color'>
            <h6 className="text-color mb-4" style={{fontSize: '13px'}}>
              Editar contacto
            </h6>
            
            <div className="form-group bg-white px-2 py-2 mb-2 border-message">
               <div className="row">
                   <div className="col">      
                        <div className="row d-flex justify-content-left">
                            <form className="row g-2">
                        <div style={{fontSize: 'medium', minWidth:'200px'}} className="col form-floating form-outline">
                            
                            <input
                            type="text"
                            className="form-control"
                            id="nameContact"
                            name='nameContact'
                            required
                            value={name}
                            onChange= {({target}) => setName(target.value.charAt(0).toUpperCase() + target.value.slice(1))}
                            placeholder= 'Nombre del contacto'
                            style={{maxHeight: '40px', fontSize:'smaller'}}
                            />
                            <label style={{fontSize: 'small'}} htmlFor="nameContact">
                            Nombre
                            </label>
                        </div>
                        <div style={{fontSize: 'medium' , minWidth:'200px'}} className="col form-floating form-outline">
                            
                            <input
                            type="text"
                            className="form-control"
                            id="lastname"
                            name='lastname'
                            required
                            value={lastname}
                            onChange= {({target}) =>setLastname(target.value.charAt(0).toUpperCase() + target.value.slice(1))}
                            placeholder= 'Contact'
                            style={{maxHeight: '40px', fontSize:'smaller'}}
                            />
                            <label style={{fontSize: 'small'}} htmlFor="lastname">
                            Apellido
                            </label>
                        </div>

                        <div style={{fontSize: 'medium', minWidth:'200px'}} className="col form-floating form-outline">
                            
                            <input
                            type="number"
                            className="form-control"
                            id="celphone"
                            name='celphone'
                            required
                            value={celphone}
                            onChange= {({target}) => setCelphone(target.value)}
                            placeholder= 'celular...'
                            style={{maxHeight: '40px', fontSize:'smaller'}}
                            />
                            <label style={{fontSize: 'small'}} htmlFor="celphone">
                            Celular
                            </label>
                        </div>

                        <div style={{fontSize: 'medium', minWidth:'200px'}} className="col form-floating form-outline">
                            
                            <input
                            type="date"
                            className="form-control"
                            id="birthday"
                            name='birthday'
                            required
                            value={birthday}
                            onChange= {({target}) => setBirthday(target.value)}
                            placeholder= 'celular...'
                            style={{maxHeight: '50px', fontSize:'smaller'}}
                            />
                            <label style={{fontSize: 'small'}} htmlFor="birthday">
                            Cumpleaños
                            </label>
                        </div>
                        
                        <div ref={divGroupsRef}>
                            <p style={{fontSize:'10px', textAlign: 'left', paddingTop:'5px', maxHeight: '2px', paddingRight:'200px'}}>Selección de grupos</p>
                            <TagInputs display= {'none'} select={true} start= {start}/>
                        </div>
            
                            </form>
                        </div>
                    </div>
                </div>
            </div>
              
          </div>

          <div className='modal-footer text-center'>
            <br />
            <button className='btn btn-sm btn-primary' onClick={() => updateContact({})}>Actualizar</button>
          </div>
        </>
    
    );
})

export default ModalEditContact
